import { render, staticRenderFns } from "./quotation-info.vue?vue&type=template&id=2eeac318&"
import script from "./quotation-info.vue?vue&type=script&lang=js&"
export * from "./quotation-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports